import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import type { AlertColor } from '@mui/material';  // Import for prop type

interface SnackbarComponentProps {
    open: boolean;
    message: string;
    severity: AlertColor;  // Use AlertColor (no need for string)
    onClose: () => void;
}

const SnackbarComponent: React.FC<SnackbarComponentProps> = ({ open, message, severity, onClose }) => (
    <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
        <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>  {/* Remove "as any" */}
            {message}
        </Alert>
    </Snackbar>
);

export default SnackbarComponent;